import { component_tool, framework_tool, utils_tool } from '../../../tool';
import React from 'react';
import ApiRoleSelect from './roleSelect/apiRoleSelect';

let { WizModal } = component_tool;
let ref
//配置项
let componentName = 'apiInfo'

const columns = [
  {
    name: "id",
    formItem: {
      type: "hidden"
    }
  },
  {
    title: "名称",
    name: "name",
    dataIndex: "name",
    searchItem: {},
    formItem: {},
    tableItem: {}
  },
  {
    title: "url",
    name: "url",
    dataIndex: "url",
    formItem: {},
    searchItem: {},
    tableItem: {}
  },
  {
    title: "请求方式",
    name: "requestMode",
    dataIndex: "requestMode",
    tableItem: {},
    dict: [
      { code: "GET", codeName: "GET" },
      { code: "POST", codeName: "POST" },
      { code: "HEAD", codeName: "HEAD" },
      { code: "PUT", codeName: "PUT" },
      { code: "DELETE", codeName: "DELETE" },
      { code: "OPTIONS", codeName: "OPTIONS" },
      { code: "TRACE", codeName: "TRACE" },
      { code: "CONNECT", codeName: "CONNECT" }
    ],
    searchItem: {
      type: "select"
    },
    formItem: {
      type: "select"
    }
  },
  {
    title: "状态",
    name: "state",
    dataIndex: "state",
    tableItem: {},
    dict: [
      { code: 0, codeName: "启用" },
      { code: 1, codeName: "禁用" }
    ],
    searchItem: {
      type: "select"
    },
    formItem: {
      type: "select"
    }
  },
  {
    title: "创建时间",
    name: "createTime",
    dataIndex: "createTime",
    tableItem: {}
  }
];

const templateConfig = {
  mainProps: {},
  content: {
    name: "WizTableList",
    params: {
      columns,
      searchBarProps: {
        cols: {
          xs: 24,
          md: 12,
          xl: 12
        },
        buttonSort:['add','delete'],

      },
      modalFormProps: {},
      dataTableProps: {
        rowKey: "id",
        selectType: "checkbox",
        isScroll: true,
        loading: false
      },
      rowOperateSort:['update','enable'],
      rowOperateView: [
        {
          key: "enable",
          custom: true,
          params: { children: "启用"},
          //需要根据接口数据变换按钮文字内容的传入方式
          textFormat: {
            recordKey: 'state',
            dirt: { 1: '启用', 0: '禁用' }
          },
          customOnClick: {
                key: "action",
                params: {
                    apiKey: "updateApiInfoByState",
                    apiParams: {}
                },
                formatParams: (rows, record, filters,callback) => {
                  const content = `${record['state'] === 0 ? "您确定要禁用吗?" : "您确定要启用?"}`;
                  WizModal.confirm({
                    title: '注意', content,
                    onOk: () => {
                      callback && callback({
                        state: record['state'] === 0 ? 1 : 0,
                        id: record['id'],
                      })
                    },
                    onCancel() { }
                  });
                  return null
                }
            }
        },
        /*{
          key: "delete",
          custom: true,
          params: {children: "删除"},
          customOnClick: {
              key: "action",
              params: {
                  apiKey: "delete",
                  apiParams: {}
              },
              formatParams: (rows, record, filters,callback) => {
                const content = "您确定要删除吗?" ;
                //const content = `${record['state'] === 0 ? "您确定要禁用吗?" : "该元素是禁用状态，您确定要启用?"}`;
                WizModal.confirm({
                  title: '注意', content,
                  onOk: () => {
                    callback && callback({
                      ids: [record['id']],
                      ...filters
                    })
                  },
                  onCancel() { }
                });
                return null
              }
          }
        },*/
        {
          key: "apiRoleModal",
          custom: true,
          params: { children: "角色管理" },
          customOnClick: {
            key: "modal",
            params: {
              modalParams: {
                title: "角色管理",
                diy: (e) => {
                  return (
                  <ApiRoleSelect
                  key={e.record.id}
                  {...e}
                  ref={(r) => {
                    ref = r && r.getWrappedInstance()
                  }}
                  />
                  )
                },
                onOk: () => {ref._doApiRoleAdd()},
                width: 700
              }
            }
          }
        }
      ],
      commonOperate: {
        add: true,
        delete:true,
        update:true
      }
    }
  }
};

const apis = {
  list: {
    path: `${componentName}/listByPage`,
    payload: {
      key: `${componentName}@listByPage`,
    }
  },
  add:{
    path: `${componentName}/addApiInfo`,
    payload: {
      key: `${componentName}@addApiInfo`,
    }
  },
  delete:{
    path: `${componentName}/deleteApiInfos`,
    payload: {
      key: `${componentName}@deleteApiInfos`,
    }
  },
  update:{
    path: `${componentName}/updateApiInfo`,
    payload: {
      key: `${componentName}@updateApiInfo`,
    }
  },
  updateApiInfoByState:{
    path: `${componentName}/updateApiInfoByState`,
    payload: {
      key: `${componentName}@updateApiInfoByState`,
    }
  }
}


let reduxTemplateCofig = (args) => {
  return {
    apis,
    componentName,
    initApiKeys: ['list'],
    needLoading: false,
    ...args
  }
};

export { reduxTemplateCofig, templateConfig };
